<template>
  <UiTooltip
    v-if="hasContent"
    position="top"
    :fixed="true"
    :auto-flip="true"
    variant="activity-user-profile"
  >
    <template #trigger>
      <span class="activity-user-hover-tooltip__trigger">
        <slot />
      </span>
    </template>
    <div class="activity-user-hover-tooltip__body">
      <p v-if="deptLine" class="activity-user-hover-tooltip__line">{{ deptLine }}</p>
      <p v-if="nameLine" class="activity-user-hover-tooltip__line">{{ nameLine }}</p>
    </div>
  </UiTooltip>
  <span v-else class="activity-user-hover-tooltip__trigger">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getActivityUserTooltipLines } from '~/composables/domain/activity/useActivityUserTooltip';

const props = defineProps({
  userId: {
    type: String,
    default: '',
  },
  userName: {
    type: String,
    default: '',
  },
  userDept: {
    type: String,
    default: '',
  },
  userRank: {
    type: String,
    default: '',
  },
});

const tooltipLines = computed(() =>
  getActivityUserTooltipLines(props.userId, {
    userNm: props.userName,
    userDept: props.userDept,
    userRank: props.userRank,
  }),
);

const deptLine = computed(() => tooltipLines.value.deptLine);
const nameLine = computed(() => tooltipLines.value.nameLine);
const hasContent = computed(() => tooltipLines.value.hasContent);
</script>

<style scoped lang="scss">
.activity-user-hover-tooltip__trigger {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  cursor: default;
}
</style>

<style lang="scss">
/* Teleport(body) 툴팁 — 활동 탭 사용자 프로필 */
.ui-tooltip.ui-tooltip--activity-user-profile {
  background-color: #58616a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  max-width: 360px;
  white-space: nowrap;

  .ui-tooltip-content {
    padding: 6px 10px;
  }

  &.ui-tooltip--top::before {
    border-color: #58616a transparent transparent transparent;
  }

  &.ui-tooltip--bottom::before {
    border-color: transparent transparent #58616a transparent;
  }

  .activity-user-hover-tooltip__line {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
    color: #fff;
  }

  .activity-user-hover-tooltip__line + .activity-user-hover-tooltip__line {
    margin-top: 2px;
  }
}
</style>
